import makeStyles from '@mui/styles/makeStyles';
import {get, isEmpty} from 'lodash';
import React from "react";
import {color, type} from "common/tokens";
import MTMarkdown from "components/MTMarkdown";
import Card from "components/redesign/Card";
import Skeleton from "components/redesign/Skeleton";

const useStyles = makeStyles(theme => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  title: {
    ...type.pageTitle,
    color: color.TEXT,
    margin: 0,
  },
  card: {
    padding: 32,
    [theme.breakpoints.down('md')]: {
      padding: 20,
    },
  },
  // Long legal copy reads better in a measured column than across the card.
  content: {
    ...type.body,
    color: color.TEXT_MUTED,
    maxWidth: 720,
    '& h1, & h2, & h3': {
      color: color.TEXT,
    },
    '& a': {
      color: color.PURPLE,
    },
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
}));

const CodeofConduct = ({title, content}) => {
  const classes = useStyles();
  const body = get(content, 'content');

  return (
    <div className={classes.page}>
      <h1 className={classes.title}>{title}</h1>
      <Card variant={'media'} className={classes.card}>
        {isEmpty(body) ? (
          <div className={classes.loading}>
            <Skeleton height={16}/>
            <Skeleton height={16}/>
            <Skeleton width={'80%'} height={16}/>
            <Skeleton width={'60%'} height={16}/>
          </div>
        ) : (
          <MTMarkdown className={classes.content}>{body}</MTMarkdown>
        )}
      </Card>
    </div>
  );
};

export default CodeofConduct;
